import React from 'react'
import DataTable from 'react-data-table-component'
import { FetchWithAuth, GetAccessToken } from '../../services/AuthService'
import Button from 'react-bootstrap/Button'
import { useCertificateTemplateInput } from './CertificateTemplateInput'
import ConfirmDelete from '../../components/ConfirmDelete'


interface IProps {
}

interface StateData {
  [stateData: string]: any
}

interface ColumnData {
  [columnData: string]: any
}

interface StateId {
  id: Number,
  contentType: String,
  cid: Number,
  author: String,
  authorName: String,
  relations: String,
  description: String,
  issuedby: String,
  managedby: Number,
  name: String,
  startnumber: Number,
  templateid: Number,
  numberprefix: Number,
  certificatelogo: String,
  validfor: Date
}


// var tempData: StateId[] = []
export default class ListCertificateTemplate extends React.Component<IProps, StateData, ColumnData> {


  constructor(props: any) {
    super(props)
    this.state = {
      stateData: [],
      columnData: [],
      showConfirmDeleteModal: false,
      confirmDeleteMessage: '',
      deleteId: 0,
      deleteLoading: false,
      oldStartNumber: 0,
    }
  }

  componentDidMount() {
    this.loadData()
    useCertificateTemplateInput.setState({ reloadList: this.loadData })
  }

  togleConfirmDelete = (id, name) => {
    if (!name) {
      name = 'template id ' + id
    }
    this.setState({
      deleteId: id,
      confirmDeleteMessage: 'Delete ' + name + '?',
      showConfirmDeleteModal: !this.state.showConfirmDeleteModal,
    })
  }

  loadData = () => {
    const columnNames: any = []

    FetchWithAuth(
      '/api/content/list/certificate_template?&columns=true', GetAccessToken()
    ).then(res => res.json()).then((resp) => {
      for (let column of ['name', 'numberprefix', 'startnumber', 'currentnumber']) {
        let name = resp.data.columns[column]['name']
        columnNames.push({ 'name': name, 'selector': column, 'sortable': true })
      }

      columnNames.push({
        'name': 'Actions', 'selector': (row, index) => {
          return <div>
            <Button variant="link" onClick={() => this.updateRow(row)}>
              Edit
            </Button>
            <Button variant="link" onClick={() => this.togleConfirmDelete(row.id, row.name)}>
              Delete
            </Button>
          </div>
        },
      })

      this.setState({ stateData: resp.data.list })
      this.setState({ columnData: columnNames })

    }).catch(err => {
      console.log(err.message)
    })
  }

  updateRow = (item) => {
    useCertificateTemplateInput.getState().open({ item })
  }

  deleteRow = () => {
    this.setState({ deleteLoading: true })
    if (this.state.deleteId <= 0) {
      return;
    }

    FetchWithAuth(
      '/api/content/delete?type=certificate_template&cid=' + this.state.deleteId, GetAccessToken()
    ).then(res => res.json()).then(data => {
      if (data.error === true) {
        window.alert('Error')
      } else {
        this.loadData()
        this.setState({
          showConfirmDeleteModal: false,
          deleteLoading: false,
        })
      }
    })
  }

  render() {
    return (
      <>
        <div>{useCertificateTemplateInput.getState().oldForm?.startnumber}</div>
        <DataTable
          columns={this.state.columnData}
          data={this.state.stateData}
          pagination
          highlightOnHover
          noHeader
          onRowClicked={(row, event) => {
            this.updateRow(row)
          }}
        />

        <ConfirmDelete
          show={this.state.showConfirmDeleteModal}
          onHide={this.togleConfirmDelete}
          confirmDelete={this.deleteRow}
          message={this.state.confirmDeleteMessage}
          loading={this.state.deleteLoading}
        />
      </>
    )
  }
}


